"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconInkSpectrumColor = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconInkSpectrumColor = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.073 11a7.999 7.999 0 1 0 13.854 8 7.999 7.999 0 0 0-13.854-8Z",
  fill: "#FF92E1"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.073 4a7.999 7.999 0 1 0 13.854 8A7.999 7.999 0 0 0 5.073 4Z",
  fill: "#FABC3F"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.073 11a7.999 7.999 0 1 0 13.854 8 7.999 7.999 0 0 0-13.854-8Z",
  fill: "#80E5FF"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m19.999 8.073-.003.176a8.002 8.002 0 0 1-3.997 6.68A7.961 7.961 0 0 0 14.927 11 7.962 7.962 0 0 0 12 8.072l.108-.062a7.995 7.995 0 0 1 7.89.063Z",
  fill: "#37D5A2"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21.927a7.996 7.996 0 0 1-4-6.997A7.965 7.965 0 0 0 12 16c1.457 0 2.823-.39 4-1.071a7.997 7.997 0 0 1-4 6.998Z",
  fill: "#AF63FF"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m12 8.072-.105.062A7.962 7.962 0 0 0 9.073 11 7.973 7.973 0 0 0 8 14.929a7.998 7.998 0 0 1-3.996-6.68l-.002-.177a7.995 7.995 0 0 1 7.998 0Z",
  fill: "#CE3168"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.001 8.072a7.962 7.962 0 0 1 2.927 2.929A7.963 7.963 0 0 1 16 14.929 7.953 7.953 0 0 1 12 16a7.963 7.963 0 0 1-4-1.07A7.973 7.973 0 0 1 9.074 11a7.963 7.963 0 0 1 2.821-2.866l.106-.062Z",
  fill: "#282828"
}));
exports.IconInkSpectrumColor = IconInkSpectrumColor;
//# sourceMappingURL=IconInkSpectrumColor.js.map